import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ModifierAddPageRBAC = {
  pageID: '9bdc7e896f64848a175f3df93e9bf4bb',
  elementID: {},
} as const

export const useRBACModifierAddPage = createUseRBAC(ModifierAddPageRBAC.elementID)

export type UseRBACModifierAddPageType = ReturnType<typeof useRBACModifierAddPage>
